import { Outlet } from "react-router-dom";
import { AdminRoute } from "@/components/providers/auth-provider";
import { DashboardShell } from "@/components/layout/dashboard-shell";

export function AdminLayout() {
	return (
		<AdminRoute>
			<DashboardShell>
				<Outlet />
			</DashboardShell>
		</AdminRoute>
	);
}
